import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '首页', path: '/' },
  { name: '科幻', path: '/category/scifi' },
  { name: '动作', path: '/category/action' },
  { name: '喜剧', path: '/category/comedy' },
  { name: '悬疑', path: '/category/suspense' },
  { name: '动画', path: '/category/animation' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-200/95 backdrop-blur-md shadow-[0_1px_0_oklch(var(--background-300))]'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="font-heading text-2xl font-bold text-primary-500">陌陌影视</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.path
                  ? 'bg-primary-500/20 text-primary-400'
                  : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-300/50'
              }`}
            >
              {link.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className="text-sm text-foreground-300 hover:text-foreground-100 transition-colors whitespace-nowrap"
          >
            关于我们
          </Link>
          <Link
            to="/category/all"
            className="px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            全部电影
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200 cursor-pointer"
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-200/98 backdrop-blur-md border-t border-background-300/60">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-300 hover:text-foreground-100 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
            <Link
              to="/category/all"
              className="mt-2 px-4 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              全部电影
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}